
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/chart-code",
      function () {
        return require("private-next-pages/tools/chart-code.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/chart-code"])
      });
    }
  